<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="docSecurite.oui"

	[label]="step1.getspan5"
	[type]="'radio'"
	[rule]="''"
	[radios]="[
		{
			label: step1.getoui,
			value: 'Oui'
		},
		{
			label: step1.getnon,
			value: 'Non'
		}
	]"
	[name]="getUid() + '_SepAtt_oui'"
>
</app-form-input>

<app-non
	*ngIf="isDocSecuriteNon()"
	[uid]="getUid()"
	[parentForm]="parentForm"

	[disabled]="disabled"
	[non]="docSecurite.non"
></app-non>
